module.exports = __webpack_public_path__ + "static/media/07FreshPreservesfinishedjarforcover-THUMBNAIL.cdf7c6c9.webp";